//@ts-nocheck
import { ReactElement, FC, useState, useLayoutEffect, useEffect } from "react";
//@ts-ignore
import stylesLogin from "../Login/Login.module.css";

import { DevTool } from "@hookform/devtools";
import { useNavigate, Link } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";

import * as z from "zod";
import { useForm } from "react-hook-form";

import Button from "../../Components/Buttons/Button";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
// import { useGetThemeSettingsList } from "../../api/themeSettings";

import { useLogin } from "../../api/login";

import Image from "../../Components/Image/Image";
import { useGetConfig } from "../../api/config";
import Head from "../../Components/Head";
//@ts-ignore

const Login: FC = (): ReactElement => {
  const navigate = useNavigate();

  const loginFormSchema = z
    .object({
      username: z
        .string()
        .min(4, { message: "Username must be of minimum 4 charaters long" }),
      password: z
        .string()
        .min(4, { message: "Password must be of minimum 4 charaters long" }),
    })
    .required();

  const {
    register,
    handleSubmit,
    setFocus,
    control,
    formState: { errors, isSubmitting, isValid },
  } = useForm({
    defaultValues: { username: "", password: "" },
    resolver: zodResolver(loginFormSchema),
  });

  const [showPassword, setShowPassword] = useState(false);
  const { mutateAsync, isError, error } = useLogin();

  const {
    data: config,
  } = useGetConfig();

  const themes = JSON.parse(localStorage.getItem("theme"));

  // [typeof null -> 'object'];
  //  [Object.is('obj', null) -> true/false]

  //to create side effect to the css variables to change according to the theme setting page values
  useLayoutEffect(() => {
    if (
      typeof themes !== "undefined" &&
      Object.is(themes, null) === false &&
      themes?.hasOwnProperty("login_background_color_primary") &&
      themes?.login_background_color_primary !== "#000000"
    ) {
      //to set the value of login bg primary color
      document.documentElement.style.setProperty(
        "--login-bg-color-primary",
        themes.login_background_color_primary
      );
    }
    if (
      typeof themes !== "undefined" &&
      Object.is(themes, null) === false &&
      themes?.hasOwnProperty("login_background_color_secondary ") &&
      themes?.login_background_color_secondary !== "#000000"
    ) {
      //to set the value of login bg secondary color
      document.documentElement.style.setProperty(
        "--login-bg-color-secondary",
        themes.login_background_color_secondary
      );
    }
    if (
      typeof themes !== "undefined" &&
      Object.is(themes, null) === false &&
      themes?.hasOwnProperty("login_input_text_icons_bg_color") &&
      themes?.login_input_text_icons_bg_color !== "#000000"
    ) {
      //to set the value of input field bg color, show password color, remember me color, forget password color
      document.documentElement.style.setProperty(
        "--login-text-icon-input-bg-color",
        themes.login_input_text_icons_bg_color
      );
    }
    if (
      typeof themes !== "undefined" &&
      Object.is(themes, null) === false &&
      themes?.hasOwnProperty("login_input_text_color") &&
      themes?.login_input_text_color !== "#000000"
    ) {
      //to set the color of the text inside INPUTs
      document.documentElement.style.setProperty(
        "--login-input-text-color",
        themes.login_input_text_color
      );
    }
    if (
      typeof themes !== "undefined" &&
      Object.is(themes, null) === false &&
      themes?.hasOwnProperty("login_button_color") &&
      themes?.login_button_color !== "#000000"
    ) {
      //to set the bg color of the login button
      document.documentElement.style.setProperty(
        "--login-button-color",
        themes.login_button_color
      );
    }
    if (
      typeof themes !== "undefined" &&
      Object.is(themes, null) === false &&
      themes?.hasOwnProperty("login_button_text_border_color") &&
      themes?.login_button_text_border_color !== "#000000"
    ) {
      //to set the border and text color of the login button
      document.documentElement.style.setProperty(
        "--login-button-text-border-color",
        themes.login_button_text_border_color
      );
    }
  }, [themes]);

  const handleFormSubmit = (data) => {
    mutateAsync({
      data: {
        email: data?.username?.trim(),
        password: data?.password,
      },
    }).then((response) => {
      localStorage.setItem("Token", JSON.stringify(response.data.tokens));
      window.location.href = "/projects?category=all"
      // navigate("/");
    });
  };

  //to add initial focus to username input field
  useEffect(() => {
    setFocus("username");
  }, [setFocus]);

  //function to toggle show password
  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <main className={stylesLogin["entire-page"]}>
      <Head title={config?.data?.title} favicon={config?.data?.favicon} />
      <div className={stylesLogin["login-card"]}>
        {/* Left Column */}
        <div className={stylesLogin["left-column"]}>
          <div className={stylesLogin["back-button"]} onClick={() => navigate("/")}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
          </div>
          
          <h1 className={stylesLogin["welcome-title"]}>Welcome Back</h1>
          <p className={stylesLogin["welcome-subtitle"]}>Sign in to access your secure dashboard.</p>

          <form
            onSubmit={handleSubmit(handleFormSubmit)}
            className={stylesLogin["form-container"]}
          >
            {isError && (
              <p className="py-4 text-red-700">
                Error: {error?.response?.data?.message}
              </p>
            )}

            <div className={stylesLogin["input-group"]}>
              <label htmlFor="username" className={stylesLogin["input-label"]}>Username</label>
              <input
                name="username"
                id="username"
                type="text"
                placeholder="Username or Email"
                className={
                  errors.username
                    ? stylesLogin["username-input-error"]
                    : stylesLogin.username
                }
                {...register("username")}
              />
              {errors.username && (
                <span className={stylesLogin["username-error"]}>
                  {errors.username?.message}
                </span>
              )}
            </div>

            <div className={stylesLogin["input-group"]}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                <label 
                  htmlFor="password" 
                  className={stylesLogin["input-label"]}
                  onClick={toggleShowPassword}
                  style={{ cursor: 'pointer', marginBottom: 0 }}
                  title="Click to toggle password visibility"
                >
                  Password
                </label>
                <Link
                  to="/forgot-password"
                  style={{
                    fontSize: "12px",
                    color: "var(--xr-cyan, #00ccf7)",
                    textDecoration: "none",
                    fontWeight: 500,
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.textDecoration = "underline")}
                  onMouseLeave={(e) => (e.currentTarget.style.textDecoration = "none")}
                >
                  Forgot Password?
                </Link>
              </div>
              <input
                name="Password"
                type={showPassword ? "text" : "password"}
                placeholder="••••••••"
                id="password"
                className={
                  errors.password
                    ? stylesLogin["password-input-error"]
                    : stylesLogin.password
                }
                {...register("password")}
              />
              {errors.password && (
                <span className={stylesLogin["password-error"]}>
                  {errors.password?.message} Password is required!!
                </span>
              )}
            </div>

            <Button
              value={isSubmitting ? "Loading..." : "Access Portfolio →"}
              btnType={"submit"}
              className={
                errors.username || errors.password || !isValid
                  ? stylesLogin["login-disable-btn"]
                  : stylesLogin["login-btn"]
              }
              disabled={errors.username || errors.password || !isValid}
            />
          </form>
        </div>

        {/* Vertical Divider */}
        <div className={stylesLogin["divider"]}></div>

        {/* Right Column */}
        <div className={stylesLogin["right-column"]}>
          <h2 className={stylesLogin["feature-title"]}>Unlock the Full Experience</h2>
          <p className={stylesLogin["feature-subtitle"]}>The public demo is just the beginning.</p>

          <div className={stylesLogin["feature-list"]}>
            <div className={stylesLogin["feature-item"]}>
              <div className={stylesLogin["feature-icon"]}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><rect x="15" y="11" width="4" height="6" rx="1"></rect><path d="M15 13v-1a2 2 0 0 1 4 0v1"></path></svg>
              </div>
              <span>Access private client projects & sensitive renders</span>
            </div>
            
            <div className={stylesLogin["feature-item"]}>
              <div className={stylesLogin["feature-icon"]}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 3 21 3 21 9"></polyline><polyline points="9 21 3 21 3 15"></polyline><line x1="21" y1="3" x2="14" y2="10"></line><line x1="3" y1="21" x2="10" y2="14"></line></svg>
              </div>
              <span>Unlock unconstrained 3D navigation & floorplans</span>
            </div>

            <div className={stylesLogin["feature-item"]}>
              <div className={stylesLogin["feature-icon"]}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
              </div>
              <span>Leave spatial comments & collaborate instantly</span>
            </div>
          </div>
        </div>
      </div>
      <DevTool control={control} /> {/* set up the dev tool */}
    </main>
  );
};

export default Login;
